import React from 'react';
import { ShoppingBag, Truck, UtensilsCrossed, Check } from 'lucide-react';
import { Button } from './ui/button';
import { productsData } from '../data/mock';

const iconMap = {
  ShoppingBag: ShoppingBag,
  Truck: Truck,
  UtensilsCrossed: UtensilsCrossed
};

const ProductsSection = () => {
  const handleOrderClick = () => {
    window.location.href = 'tel:773-495-4615';
  };

  return (
    <section id="products" className="products-section py-20 md:py-32 relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            {productsData.title}
          </h2>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto opacity-80">
            From farmers markets to private events, we bring delicious vegan & gluten-free treats to you
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {productsData.services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div key={service.id} className="product-card rounded-3xl p-8 group">
                <div className="product-icon-wrapper mb-6">
                  <IconComponent className="h-12 w-12" />
                </div>
                
                <h3 className="text-2xl font-bold mb-4">
                  {service.title}
                </h3>
                
                <p className="text-lg mb-6 opacity-80">
                  {service.description}
                </p>

                <ul className="space-y-3 mb-8">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-center gap-3">
                      <div className="feature-check">
                        <Check className="h-4 w-4" />
                      </div>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button 
                  className="w-full product-cta"
                  onClick={handleOrderClick}
                >
                  Get Started
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
